document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.vid-vol').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var video = this.closest('.video-section').querySelector('video');
      video.muted = this.classList.contains('vol-on');
      this.classList.toggle('vol-on');
    });
  });

  document.querySelectorAll('.newsletter-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var wrapper = this.closest('.newsletter__wrapper');
      var img = wrapper.querySelector('.feed-mm img');
      var gif = wrapper.querySelector('.feed-gif');
      if (img) img.style.display = 'none';
      if (gif) gif.style.display = 'block';
      this.querySelector('input').style.display = 'none';
    });
  });
});
